module.exports = "/davinci/assets/a7be7d68132003f256bb79ba9fc01863.png";